import { useContext } from "react";
import { trpc } from "../../../trpc";
import MerchantContext from "../../../contexts/MerchantContext";
import { Card, CardContent } from "@/components/ui/card";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Spinner } from "@/components/ui/spinner";
import { cn } from "@/lib/utils";

type Step2SelectProjectProps = {
  selectedProjectId: string;
  onSelect: (projectId: string) => void;
};

const Step2SelectProject = ({ selectedProjectId, onSelect }: Step2SelectProjectProps) => {
  const { merchantId } = useContext(MerchantContext);

  const { data: projects, isLoading } = trpc.projects.list.useQuery(
    { merchantId: merchantId || "" },
    { enabled: !!merchantId }
  );

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="flex flex-col items-center gap-4">
          <Spinner size="xl" />
          <p className="text-gray-600">Cargando proyectos...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4">
      <div>
        <p className="mb-2 text-lg font-bold">Selecciona un Proyecto (opcional)</p>
        <p className="mb-4 text-sm text-gray-600">
          Asocia los leads del envío a un proyecto, o continúa sin proyecto.
        </p>
      </div>

      <div className="flex flex-col gap-3">
        <Card
          className={cn(
            "cursor-pointer border-2 transition-all hover:border-purple-300 hover:bg-purple-50/50",
            selectedProjectId === "" ? "border-purple-500 bg-purple-50" : "border-gray-200"
          )}
          onClick={() => onSelect("")}
        >
          <CardContent className="p-4">
            <p className="font-medium">Sin proyecto</p>
            <p className="text-sm text-gray-500">
              Los leads no se asociarán a ningún proyecto.
            </p>
          </CardContent>
        </Card>

        <RadioGroup value={selectedProjectId} onValueChange={onSelect}>
          <div className="flex flex-col gap-3">
            {(projects ?? []).map((project) => (
              <Card
                key={project.id}
                className={cn(
                  "cursor-pointer border-2 transition-all hover:border-purple-300 hover:bg-purple-50/50",
                  selectedProjectId === project.id
                    ? "border-purple-500 bg-purple-50"
                    : "border-gray-200"
                )}
                onClick={() => onSelect(project.id)}
              >
                <CardContent className="p-4">
                  <div className="flex items-center gap-3">
                    <RadioGroupItem value={project.id} />
                    <div className="flex-1">
                      <p className="font-medium">{project.name}</p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </RadioGroup>
      </div>
    </div>
  );
};

export default Step2SelectProject;
